import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "./_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "./interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1} from "./defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "./index-877ea290.js";
import {r as require$$3} from "./clsx.m-5dc7436b.js";
import {c as core} from "./index-0a000c27.js";
import {f as formControlState_1} from "./formControlState-63450f78.js";
import {u as useFormControl_1} from "./useFormControl-9e2a3560.js";
import {c as capitalize} from "./capitalize-0607751a.js";
import {u as useThemeProps_1, s as styled_1} from "./useThemeProps-ef190a94.js";
import _jsxRuntime from "react/jsx-runtime";
var formLabelClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getFormLabelUtilityClasses = getFormLabelUtilityClasses;
  function getFormLabelUtilityClasses(slot) {
    return (0, core.generateUtilityClass)("MuiFormLabel", slot);
  }
  const formLabelClasses = (0, core.generateUtilityClasses)("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]);
  var _default = formLabelClasses;
  exports.default = _default;
});
var FormLabel_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.FormLabelRoot = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _formControlState = interopRequireDefault(formControlState_1);
  var _useFormControl = interopRequireDefault(useFormControl_1);
  var _capitalize = interopRequireDefault(capitalize);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _styled = interopRequireDefault(styled_1);
  var _formLabelClasses = _interopRequireWildcard(formLabelClasses_1);
  const _excluded = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      color,
      focused,
      disabled,
      error,
      filled,
      required
    } = ownerState;
    const slots = {
      root: ["root", `color${(0, _capitalize.default)(color)}`, disabled && "disabled", error && "error", filled && "filled", focused && "focused", required && "required"],
      asterisk: ["asterisk", error && "error"]
    };
    return (0, core.unstable_composeClasses)(slots, _formLabelClasses.getFormLabelUtilityClasses, classes);
  };
  const FormLabelRoot = (0, _styled.default)("label", {
    name: "MuiFormLabel",
    slot: "Root",
    overridesResolver: ({
      ownerState
    }, styles) => {
      return (0, _extends2.default)({}, styles.root, ownerState.color === "secondary" && styles.colorSecondary, ownerState.filled && styles.filled);
    }
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    color: theme.palette.text.secondary
  }, theme.typography.body1, {
    lineHeight: "1.4375em",
    padding: 0,
    position: "relative",
    [`&.${_formLabelClasses.default.focused}`]: {
      color: theme.palette[ownerState.color].main
    },
    [`&.${_formLabelClasses.default.disabled}`]: {
      color: theme.palette.text.disabled
    },
    [`&.${_formLabelClasses.default.error}`]: {
      color: theme.palette.error.main
    }
  }));
  exports.FormLabelRoot = FormLabelRoot;
  const AsteriskComponent = (0, _styled.default)("span", {
    name: "MuiFormLabel",
    slot: "Asterisk",
    overridesResolver: (props, styles) => styles.asterisk
  })(({
    theme
  }) => ({
    [`&.${_formLabelClasses.default.error}`]: {
      color: theme.palette.error.main
    }
  }));
  const FormLabel2 = /* @__PURE__ */ React$1.forwardRef(function FormLabel3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiFormLabel"
    });
    const {
      children,
      className,
      component = "label"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const muiFormControl = (0, _useFormControl.default)();
    const fcs = (0, _formControlState.default)({
      props,
      muiFormControl,
      states: ["color", "required", "focused", "disabled", "error", "filled"]
    });
    const ownerState = (0, _extends2.default)({}, props, {
      color: fcs.color || "primary",
      component,
      disabled: fcs.disabled,
      error: fcs.error,
      filled: fcs.filled,
      focused: fcs.focused,
      required: fcs.required
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(FormLabelRoot, (0, _extends2.default)({
      as: component,
      ownerState,
      className: (0, _clsx.default)(classes.root, className),
      ref
    }, other, {
      children: [children, fcs.required && /* @__PURE__ */ (0, _jsxRuntime.jsxs)(AsteriskComponent, {
        ownerState,
        "aria-hidden": true,
        className: classes.asterisk,
        children: [" ", "*"]
      })]
    }));
  });
  var _default = FormLabel2;
  exports.default = _default;
});
var FormLabel = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    formLabelClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _FormLabel.default;
    }
  });
  Object.defineProperty(exports, "formLabelClasses", {
    enumerable: true,
    get: function() {
      return _formLabelClasses.default;
    }
  });
  var _FormLabel = _interopRequireWildcard(FormLabel_1);
  Object.keys(_FormLabel).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _FormLabel[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _FormLabel[key];
      }
    });
  });
  var _formLabelClasses = _interopRequireWildcard(formLabelClasses_1);
  Object.keys(_formLabelClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _formLabelClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _formLabelClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(FormLabel);
export {FormLabel as F, __pika_web_default_export_for_treeshaking__ as _};
